
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'
import type { CityTypeInfo } from '@xt/client/entities/kindred-spirit/kindred-spirit'
import LazyImg from '@xt/www/components/lazyImg/index.vue'
import HeaderGroup from '../HeaderGroup/index.vue'
import { EnumCityStatus } from '@xt/client/entities/kindred-spirit/cities'
import CityAvatar from '../CityAvatar/index.vue'
import { Observer } from 'mobx-vue'

@Observer
@Component({
  components: {
    LazyImg,
    HeaderGroup,
    CityAvatar
  }
})
export default class CityCard extends Vue {
  @Prop({ required: true, type: Object }) readonly dataSource!: CityTypeInfo & { subTitle: string }

  get EnumCityStatus() {
    return EnumCityStatus
  }

  get btnText() {
    return this.dataSource.status === EnumCityStatus.Assistance ? '助力' : this.dataSource.recruitStatus === true ? '负责人招募' : ''
  }

  @Emit('to-city-page')
  handleClick() {
    return this.dataSource.id
  }

  handleOperation() {
    if (this.dataSource.status === EnumCityStatus.Assistance) {
      this.$emit('show-assistance')
    } else if (this.dataSource.recruitStatus === true) {
      this.$emit('show-recruit')
    }
  }

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
